import { render, staticRenderFns } from "./BaseLayoutSpaced.vue?vue&type=template&id=1bf67b6e&functional=true"
import script from "./BaseLayoutSpaced.vue?vue&type=script&lang=js"
export * from "./BaseLayoutSpaced.vue?vue&type=script&lang=js"
import style0 from "./BaseLayoutSpaced.vue?vue&type=style&index=0&id=1bf67b6e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports